/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PatchedPublishsetTagEditRequest } from '../types/PatchedPublishsetTagEdit';
import type { PublishsetTagEditResponse } from '../types/PublishsetTagEdit';

export type PublishsetTagsPartialUpdateRequest = PatchedPublishsetTagEditRequest;
export type PublishsetTagsPartialUpdateResponse = PublishsetTagEditResponse;

export type PublishsetTagsPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this publishset tag.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/publishset_tags/{id}/
 *
 * ```yaml
 * operationId: publishset_tags_partial_update
 * tags:
 *   - publishset_tags
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedPublishsetTagEdit'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedPublishsetTagEdit'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedPublishsetTagEdit'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PublishsetTagEdit'
 *     description: ''
 * ```
 */
export const publishsetTagsPartialUpdateOperation = ({
  id,
  ...rest
}: PublishsetTagsPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/publishset_tags/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/publishset_tags/{id}/' };
  };

/**
 * PATCH /dmx-server/publishset_tags/{id}/
 *
 * ```yaml
 * operationId: publishset_tags_partial_update
 * tags:
 *   - publishset_tags
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedPublishsetTagEdit'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedPublishsetTagEdit'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedPublishsetTagEdit'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PublishsetTagEdit'
 *     description: ''
 * ```
 */
export const publishsetTagsPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: PublishsetTagsPartialUpdateQuery;
  request: PatchedPublishsetTagEditRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PublishsetTagEditResponse>> => {
  const operation = publishsetTagsPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
